module.exports = __webpack_public_path__ + "static/media/Bartlett, San Francisco, CA1.7e05f859.jpg";